























































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { PaymentVariables } from '@/Admin/ProgramVariables/Payments/PaymentVariables';
import BuildEntityComponent from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import RadioToggle from '@/Shared/RadioToggle.vue';
import { ProcessorVariables } from '@/Payment/ProcessorVariables';
import { PaymentProcessor } from '@/Payment/Enums';
import PaypalCredentialsConfig from './Paypal/PaypalCredentials.vue';
import { PaypalCredentials } from './Paypal/PaypalCredentials';
import VantivCredentialsConfig from './Vantiv/VantivCredentials.vue';
import EXactPageKeysConfig from './EXact/EXactPageKeysConfig.vue';
import VatsAPI from '@/Shared/VatsAPI';
import { AxiosResponse } from 'axios';

const component = mixins(LocationBasedMixin, BuildEntityComponent<ProcessorVariables>()).extend({
    components: {
        RadioToggle,
        PaypalCredentialsConfig,
        VantivCredentialsConfig,
        EXactPageKeysConfig
    },
    data() {
        return {
            i18nPrefix: 'admin.programVariables.payments.processorConfig',
            paymentProcessors:
                Object.keys(PaymentProcessor)
                .filter(k => typeof (PaymentProcessor as any)[k] !== 'string'),
            updatingCredentials: false
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/Payments/ProcessorVariables`;
        },
        paypalSelected(): boolean {
            return this.entity.processor === PaymentProcessor.PAYPAL;
        },
        e_xactSelected(): boolean {
            return this.entity.processor === PaymentProcessor.E_XACT;
        },
        vantivSelected(): boolean {
            return this.entity.processor === PaymentProcessor.VANTIV ||
                this.entity.processor === PaymentProcessor.VANTIV_HOSTED;
        }
    },
    methods: {
        afterSave(response: AxiosResponse<ProcessorVariables>): ProcessorVariables {
            this.$bvToast.toast(this.$i18n.t(`${this.i18nPrefix}.processorConfigSaved`).toString(), {
                title: this.$i18n.t('common.save').toString(),
                autoHideDelay: 5000
            });

            return response.data;
        },
        updateCredentials() {
            this.updatingCredentials = true;
        },
        credentialsUpdated() {
            this.updatingCredentials = false;

            this.$bvToast.toast(this.$i18n.t(`${this.i18nPrefix}.credentialsUpdatedMessage`).toString(), {
                title: this.$i18n.t('common.save').toString(),
                autoHideDelay: 5000
            });
        }
    }
});

export default component;

